import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isPersonalizedChurnModalOpen: false,
  isEtSelectionModalOpen: false,
}

const churnModalsSlice = createSlice({
  name: 'churnModals',
  initialState,
  reducers: {
    startChurnModalFlow: (state) => {
      state.isPersonalizedChurnModalOpen = true
      state.isEtSelectionModalOpen = false
    },
    moveToEtSelectionModal: (state) => {
      state.isPersonalizedChurnModalOpen = false
      state.isEtSelectionModalOpen = true
    },
    resetChurnModals: (state) => {
      state.isPersonalizedChurnModalOpen = false
      state.isEtSelectionModalOpen = false
    }
  }
})

export const { reducer,
  actions: {
    startChurnModalFlow,
    moveToEtSelectionModal,
    resetChurnModals
  } } = churnModalsSlice
